module.exports = __webpack_public_path__ + "img/meter.139b32d1.svg";